import { useMutation } from "@tanstack/react-query";
import { FileService } from "../../../../services/file/file.service";

type Variables = {
  docId: string;
  fields: {};
  listId?: string;
};

export const useUpdateDocument = () => {
  return useMutation({
    mutationFn: (vars: Variables) => FileService.updateDoc(vars),
  });
};
